import React from "react";
import { empiTheme } from "./styles/empiTheme";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Navbar() {
  return (
    <header style={header}>
      <nav style={nav} className="empi-nav">
        <a href="/" style={brand} aria-label="EmPi homepage">
          <img src="/empi-wordmark.svg" alt="EmPi" style={brandLogo} />
        </a>

        <div style={actions} className="empi-nav-actions">
          <button onClick={() => scrollToId("philosophy")} style={btnLink}>
            About
          </button>
          <button onClick={() => scrollToId("roadmap")} style={btnLink}>
            Roadmap
          </button>
          <button onClick={() => scrollToId("waitlist")} style={btnPrimary}>
            Pilot Status
          </button>
        </div>
      </nav>
    </header>
  );
}

const header = {
  position: "sticky",
  top: 0,
  zIndex: 50,
  background: "rgba(255, 255, 255, 0.9)",
  backdropFilter: "blur(8px)",
  WebkitBackdropFilter: "blur(8px)",
  borderBottom: `1px solid ${empiTheme.colors.border}`,
};

const nav = {
  maxWidth: empiTheme.layout.maxWidth,
  margin: "0 auto",
  padding: "14px 20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
};

const brand = {
  position: "relative",
  width: 112,
  height: 40,
  flexShrink: 0,
  display: "block",
};

const brandLogo = {
  position: "absolute",
  left: 0,
  bottom: -14,
  width: 112,
  height: "auto",
  display: "block",
};

const actions = {
  display: "flex",
  gap: 14,
  alignItems: "center",
};

const btnLink = {
  background: "transparent",
  border: "none",
  padding: "8px 10px",
  cursor: "pointer",
  fontSize: 14,
  color: empiTheme.colors.text,
};

const btnPrimary = {
  background: "linear-gradient(180deg, #F8C9B6 0%, #F4A98A 100%)",
  color: "#3A2A24",
  border: "1px solid #F2B79D",
  boxShadow: "0 5px 12px rgba(244, 169, 138, 0.24)",
  padding: "10px 14px",
  borderRadius: empiTheme.radius.button,
  cursor: "pointer",
  fontSize: 14,
  fontWeight: 700,
};
